import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#DFE5F2", d: "M8 10 4 6h8l-4 4Z" }));
export default SvgDown;
